var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import cloneDeep from 'lodash/cloneDeep';
import uniq from 'lodash/uniq';
import { getCategoriesForChart } from '../utils/sorting/getChartCategories';
import constants from './constants';
import chartUtils from '../utils/chart-utils';

var XAXIS_BASE = {
    title: {
        text: 'LabelName',
        style: {
            fontSize: '12px'
        }
    },
    labels: {
        style: {
            fontWeight: 700
        }
    }
};

var RADIALBAR_XAXIS = {
    tickInterval: 1,
    tickmarkPlacement: 'on',
    labels: {
        align: 'right',
        useHTML: true,
        allowOverlap: true,
        step: 1,
        y: 3.
    },
    lineWidth: 0
};

var configureXAxis = function configureXAxis(widgetConfig, seriesDataObj, customConfig, seriesConfig) {
    var config = cloneDeep(XAXIS_BASE);
    var seriesDatalength = seriesDataObj && seriesDataObj.length;

    config = _extends({}, config, cloneDeep(customConfig));

    var ChartConfig = widgetConfig.ChartConfig,
        BubbleChartConfig = widgetConfig.BubbleChartConfig,
        HistogramConfig = widgetConfig.HistogramConfig,
        GaugeConfig = widgetConfig.GaugeConfig,
        FlowConfig = widgetConfig.FlowConfig,
        BulletConfig = widgetConfig.BulletConfig,
        HeatmapConfig = widgetConfig.HeatmapConfig,
        TreemapConfig = widgetConfig.TreemapConfig,
        XRangeConfig = widgetConfig.XRangeConfig;


    if (BubbleChartConfig) return config;

    if (XRangeConfig) {
        config = _extends({}, config);
        if (seriesDataObj.typeClass.toLowerCase() == 'datetime') config.type = 'datetime';
        return config;
    }
    if (ChartConfig && ChartConfig.ChartType.toLowerCase() === constants.chartTypes.RADIALBAR) {
        config = _extends({}, config, RADIALBAR_XAXIS, cloneDeep(customConfig));
        config.title.useHTML = true;
    }

    if (BubbleChartConfig) return config;

    if (BulletConfig) {
        var categoryAxis = BulletConfig.Series[0].CategoryAxis;
        if (categoryAxis) return { categories: [seriesDataObj[0][categoryAxis]] };else return { categories: [seriesConfig["SeriesName"]] };
    }
    if (HeatmapConfig) {
        var heatmapCategories = uniq(seriesDataObj.map(function (r) {
            return r[HeatmapConfig.RowField];
        }));
        return { categories: heatmapCategories };
    }
    if (ChartConfig && (ChartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL || ChartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID)) return {};
    if (GaugeConfig || FlowConfig || TreemapConfig) return null;

    if (HistogramConfig) {
        var XAxisName = HistogramConfig.XAxisName;
        var ValueFormat = HistogramConfig.ValueFormat,
            CurrencySymbol = HistogramConfig.CurrencySymbol,
            BaseFormat = HistogramConfig.BaseFormat;

        var bins = seriesDataObj['Bin Edges'];

        config.title.text = XAxisName;
        config.categories = bins;
        config.categories = [];
        if (bins.length > 0) bins.forEach(function (c) {
            var category = chartUtils.format(c, ValueFormat, CurrencySymbol, null, BaseFormat);

            config["categories"].push(category);
        });

        return config;
    }

    var categories = getCategoriesForChart(ChartConfig, seriesDataObj);
    var useCategories = categories && categories.length > 0;
    var axisType = useCategories ? 'category' : 'linear';
    categories = categories.filter(function (category) {
        return category !== "";
    });

    if (useCategories) {
        if (ChartConfig.ChartType.toLowerCase() === 'waterfall') config.categories = '';else config.categories = categories;
    }
    config.type = axisType;

    var GridLines = ChartConfig.GridLines,
        LabelName = ChartConfig.LabelName,
        HideXAxis = ChartConfig.HideXAxis,
        CategoryDateFormat = ChartConfig.CategoryDateFormat;

    config.title.text = LabelName;
    config.gridLineWidth = ['Both', 'XAxis'].includes(GridLines) ? 1 : 0;

    if (HideXAxis) {
        config.labels.enabled = false;
        config.tickWidth = 0;
    }

    config = _extends({}, config, {
        type: axisType,
        title: _extends({}, config.title, {
            text: LabelName
        }),
        gridLineWidth: ['Both', 'XAxis'].includes(GridLines) ? 1 : 0,
        labels: _extends({}, config.labels, {
            formatter: function formatter() {
                if (CategoryDateFormat) return chartUtils.formatDate(this.value, CategoryDateFormat);else if (ChartConfig.ChartType.toLowerCase() == "bubble") return chartUtils.format(this.value, ChartConfig.ValueFormat, ChartConfig.CurrencySymbol, null, ChartConfig.BaseFormat);
                return this.value;
            }
        })
    });

    return config;
};

export default configureXAxis;